import React from "react";
import { useTranslation } from "react-i18next";

// ponytail: hardcoded on purpose, so the public pages do not ship country-state-city.
// Values are the English names the settings form saves; "United Kingdom" also matches the
// four UK nations (see ActorFilterList).
const countries = ["Canada", "United States", "France", "United Kingdom"];

const CountryDropdown = ({ selectedValue, onOptionSelect }) => {
  const { t } = useTranslation();

  return (
    <div className="dropdown-content">
      {countries.map((country) => (
        <button
          key={country}
          className={country === selectedValue ? "selected" : ""}
          onClick={() => onOptionSelect(country)}
        >
          {t(country)}
        </button>
      ))}
    </div>
  );
};
export default CountryDropdown;
